export default "__VITE_ASSET__bb41dabb__"